import classNames from "classnames";
import styles from "../Digikala.module.css";

export default function DigikalaBanner({ banner }) {
  return (
    <div className="row rtl d-flex justify-content-center flex-wrap py-4 mt-4">
      <div className="col-12">
        <img
          src={banner.image}
          className={classNames(styles.digikalaRadius, styles.digikalaBanner)}
          alt="تحویل به مشتری"
        />
      </div>
    </div>
  );
}
